"use strict";
// tslint:disable
// eslint-disable
/**
 * HEM Workbench API Specification
 * Health Economics Workbench API Specification
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelsApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 * no description
 */
class ModelsApi extends runtime.BaseAPI {
    /**
     * Approve access to model with provided modelUuid
     */
    approveModelAccessRequestRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling approveModelAccessRequest.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.role === null || requestParameters.role === undefined)) {
                throw new runtime.RequiredError('role', 'Required parameter requestParameters.role was null or undefined when calling approveModelAccessRequest.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.userId === null || requestParameters.userId === undefined)) {
                throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling approveModelAccessRequest.');
            }
            const queryParameters = {};
            if (requestParameters.role !== undefined) {
                queryParameters['role'] = requestParameters.role;
            }
            if (requestParameters.userId !== undefined) {
                queryParameters['userId'] = requestParameters.userId;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/approveAccess`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Approve access to model with provided modelUuid
     */
    approveModelAccessRequest(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.approveModelAccessRequestRaw(requestParameters);
        });
    }
    /**
     * Create a copy of existing models, by specifying what should be copied
     * Clone a model entry
     */
    cloneModelRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling cloneModel.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.modelCloneDTO === null || requestParameters.modelCloneDTO === undefined)) {
                throw new runtime.RequiredError('modelCloneDTO', 'Required parameter requestParameters.modelCloneDTO was null or undefined when calling cloneModel.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/clone/{modelUuid}`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ModelCloneDTOToJSON(requestParameters.modelCloneDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ModelDTOFromJSON(jsonValue));
        });
    }
    /**
     * Create a copy of existing models, by specifying what should be copied
     * Clone a model entry
     */
    cloneModel(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.cloneModelRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Create a one to one copy of a model
     * Clone a model entry
     */
    cloneModelAllRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling cloneModelAll.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/clone/{modelUuid}/all`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ModelDTOFromJSON(jsonValue));
        });
    }
    /**
     * Create a one to one copy of a model
     * Clone a model entry
     */
    cloneModelAll(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.cloneModelAllRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Create new model
     */
    createModelRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.updatableModelDTO === null || requestParameters.updatableModelDTO === undefined)) {
                throw new runtime.RequiredError('updatableModelDTO', 'Required parameter requestParameters.updatableModelDTO was null or undefined when calling createModel.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.UpdatableModelDTOToJSON(requestParameters.updatableModelDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ModelDTOFromJSON(jsonValue));
        });
    }
    /**
     * Create new model
     */
    createModel(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createModelRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Delete drafted model with provided modelUuid
     */
    deleteDraftModelRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling deleteDraftModel.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/draft`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete drafted model with provided modelUuid
     */
    deleteDraftModel(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteDraftModelRaw(requestParameters);
        });
    }
    /**
     * Delete model with provided modelUuid
     */
    deleteModelRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling deleteModel.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete model with provided modelUuid
     */
    deleteModel(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteModelRaw(requestParameters);
        });
    }
    /**
     * Provides Excel file containing list of all models
     */
    downloadAllModelListRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.history !== undefined) {
                queryParameters['history'] = requestParameters.history;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/list`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.BlobApiResponse(response);
        });
    }
    /**
     * Provides Excel file containing list of all models
     */
    downloadAllModelList(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.downloadAllModelListRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Download model
     */
    downloadModelRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling downloadModel.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/download`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.BlobApiResponse(response);
        });
    }
    /**
     * Download model
     */
    downloadModel(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.downloadModelRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * List all eligible models
     */
    getCreatorStewardOwnerModelsRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/externalization/getCreatorStewardOwnerModels/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.ModelDTOFromJSON));
        });
    }
    /**
     * List all eligible models
     */
    getCreatorStewardOwnerModels() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCreatorStewardOwnerModelsRaw();
            return yield response.value();
        });
    }
    /**
     * Get guided tour viewed value
     */
    getHasViewedGuidedTourRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.type === null || requestParameters.type === undefined)) {
                throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling getHasViewedGuidedTour.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.code === null || requestParameters.code === undefined)) {
                throw new runtime.RequiredError('code', 'Required parameter requestParameters.code was null or undefined when calling getHasViewedGuidedTour.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/tour/guidedTour/{type}/{code}`.replace(`{${"type"}}`, encodeURIComponent(String(requestParameters.type))).replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.GuidingTourDTOFromJSON(jsonValue));
        });
    }
    /**
     * Get guided tour viewed value
     */
    getHasViewedGuidedTour(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getHasViewedGuidedTourRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get model with provided modelUuid
     */
    getModelRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling getModel.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ModelDetailDTOFromJSON(jsonValue));
        });
    }
    /**
     * Get model with provided modelUuid
     */
    getModel(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getModelRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get model items tree
     */
    getModelItemsTreeRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling getModelItemsTree.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/tree`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.ModelTreeItemDTOFromJSON));
        });
    }
    /**
     * Get model items tree
     */
    getModelItemsTree(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getModelItemsTreeRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get model items tree with information about last updator
     */
    getModelItemsTreeAuditedRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling getModelItemsTreeAudited.');
            }
            const queryParameters = {};
            if (requestParameters.filterTags) {
                queryParameters['filterTags'] = requestParameters.filterTags;
            }
            if (requestParameters.excludeTags) {
                queryParameters['excludeTags'] = requestParameters.excludeTags;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/treeaudited`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.ModelTreeItemAuditedDTOFromJSON));
        });
    }
    /**
     * Get model items tree with information about last updator
     */
    getModelItemsTreeAudited(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getModelItemsTreeAuditedRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get model items tree with information about last updator
     */
    getModelItemsTreeAuditedTHRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling getModelItemsTreeAuditedTH.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/treeauditedTH`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ModelTreeTHItemAuditedDTOFromJSON(jsonValue));
        });
    }
    /**
     * Get model items tree with information about last updator
     */
    getModelItemsTreeAuditedTH(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getModelItemsTreeAuditedTHRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * List all models
     */
    getModelListRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.ModelDTOFromJSON));
        });
    }
    /**
     * List all models
     */
    getModelList() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getModelListRaw();
            return yield response.value();
        });
    }
    /**
     * Dynamic Search
     */
    getModelsForDynamicFiltersRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.dynamicFiltersDTO === null || requestParameters.dynamicFiltersDTO === undefined)) {
                throw new runtime.RequiredError('dynamicFiltersDTO', 'Required parameter requestParameters.dynamicFiltersDTO was null or undefined when calling getModelsForDynamicFilters.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/dynamicSearch`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.DynamicFiltersDTOToJSON(requestParameters.dynamicFiltersDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.DynamicFiltersResponseDTOFromJSON(jsonValue));
        });
    }
    /**
     * Dynamic Search
     */
    getModelsForDynamicFilters(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getModelsForDynamicFiltersRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Checks if a model already exists with the given model metadata, comparison is case-insensitive
     */
    modelExistsByModelParametersRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.updatableModelDTO === null || requestParameters.updatableModelDTO === undefined)) {
                throw new runtime.RequiredError('updatableModelDTO', 'Required parameter requestParameters.updatableModelDTO was null or undefined when calling modelExistsByModelParameters.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/model/name/exists`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.UpdatableModelDTOToJSON(requestParameters.updatableModelDTO),
            });
            return new runtime.TextApiResponse(response);
        });
    }
    /**
     * Checks if a model already exists with the given model metadata, comparison is case-insensitive
     */
    modelExistsByModelParameters(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.modelExistsByModelParametersRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Publish model
     */
    publishModelRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling publishModel.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/publish`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Publish model
     */
    publishModel(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.publishModelRaw(requestParameters);
        });
    }
    /**
     * Request access to model with provided modelUuid
     */
    sendModelAccessRequestedRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling sendModelAccessRequested.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.reason === null || requestParameters.reason === undefined)) {
                throw new runtime.RequiredError('reason', 'Required parameter requestParameters.reason was null or undefined when calling sendModelAccessRequested.');
            }
            const queryParameters = {};
            if (requestParameters.reason !== undefined) {
                queryParameters['reason'] = requestParameters.reason;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/requestAccess`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Request access to model with provided modelUuid
     */
    sendModelAccessRequested(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.sendModelAccessRequestedRaw(requestParameters);
        });
    }
    /**
     * Share model with provided modelUuid
     */
    sendModelShareEmailRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling sendModelShareEmail.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.shareInstanceDTO === null || requestParameters.shareInstanceDTO === undefined)) {
                throw new runtime.RequiredError('shareInstanceDTO', 'Required parameter requestParameters.shareInstanceDTO was null or undefined when calling sendModelShareEmail.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/share`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ShareInstanceDTOToJSON(requestParameters.shareInstanceDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Share model with provided modelUuid
     */
    sendModelShareEmail(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.sendModelShareEmailRaw(requestParameters);
        });
    }
    /**
     * Set user as model VEST lead for model with provided modelUuid
     */
    setModelVestLeadRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling setModelVestLead.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.userId === null || requestParameters.userId === undefined)) {
                throw new runtime.RequiredError('userId', 'Required parameter requestParameters.userId was null or undefined when calling setModelVestLead.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/vestlead/{userId}`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))).replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters.userId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Set user as model VEST lead for model with provided modelUuid
     */
    setModelVestLead(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.setModelVestLeadRaw(requestParameters);
        });
    }
    /**
     * Share Instance with provided isid
     */
    shareInstanceWithUserRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.identifier === null || requestParameters.identifier === undefined)) {
                throw new runtime.RequiredError('identifier', 'Required parameter requestParameters.identifier was null or undefined when calling shareInstanceWithUser.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.id === null || requestParameters.id === undefined)) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling shareInstanceWithUser.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.shareInstanceDTO === null || requestParameters.shareInstanceDTO === undefined)) {
                throw new runtime.RequiredError('shareInstanceDTO', 'Required parameter requestParameters.shareInstanceDTO was null or undefined when calling shareInstanceWithUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/ownership/share/{identifier}/instance/{id}`.replace(`{${"identifier"}}`, encodeURIComponent(String(requestParameters.identifier))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ShareInstanceDTOToJSON(requestParameters.shareInstanceDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Share Instance with provided isid
     */
    shareInstanceWithUser(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.shareInstanceWithUserRaw(requestParameters);
        });
    }
    /**
     * Update model with provided modelUuid
     */
    updateModelRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling updateModel.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.updatableModelDTO === null || requestParameters.updatableModelDTO === undefined)) {
                throw new runtime.RequiredError('updatableModelDTO', 'Required parameter requestParameters.updatableModelDTO was null or undefined when calling updateModel.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.UpdatableModelDTOToJSON(requestParameters.updatableModelDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ModelDetailDTOFromJSON(jsonValue));
        });
    }
    /**
     * Update model with provided modelUuid
     */
    updateModel(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateModelRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Share scenario with provided isid
     */
    updateShareInstanceRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.scenarioId === null || requestParameters.scenarioId === undefined)) {
                throw new runtime.RequiredError('scenarioId', 'Required parameter requestParameters.scenarioId was null or undefined when calling updateShareInstance.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.updateScenarioDTO === null || requestParameters.updateScenarioDTO === undefined)) {
                throw new runtime.RequiredError('updateScenarioDTO', 'Required parameter requestParameters.updateScenarioDTO was null or undefined when calling updateShareInstance.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/updateShareInstance/{scenarioId}`.replace(`{${"scenarioId"}}`, encodeURIComponent(String(requestParameters.scenarioId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.UpdateScenarioDTOToJSON(requestParameters.updateScenarioDTO),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Share scenario with provided isid
     */
    updateShareInstance(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateShareInstanceRaw(requestParameters);
        });
    }
}
exports.ModelsApi = ModelsApi;
